import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const logIn = (login, password) => ({
    type: actionTypes.LOG_IN,
    payload: {
        login: login,
        password: password
    }
});

export const logOut = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_LOG_OUT
    },
    method: handlers.LOG_OUT,
    tabId: 0
});

export const logInAsAnotherUser = (login, password) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_VALIDATE_USER_PASSWORD,
        params: {
            login: login,
            password: password
        }
    },
    method: handlers.VALIDATE_USER_PASSWORD,
    tabId: 0
});

export const authenticateUser = (login, password, next) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_VALIDATE_USER_PASSWORD,
        params: {
            login: login,
            password: password
        }
    },
    method: handlers.VALIDATE_USER_PASSWORD_AUTHENTICATION,
    tabId: 0,
    next: next
});

export const setLogin = (login) => ({
    type: actionTypes.LOG_IN_SET_LOGIN,
    payload: {
        login: login
    }
});

export const setPassword = (password) => ({
    type: actionTypes.LOG_IN_SET_PASSWORD,
    payload: {
        password: password
    }
});
